module.exports = __webpack_public_path__ + "static/media/form-icon.d7d75c1e.svg";